var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.55273 33.4033C8.55273 32.4368 9.33624 31.6533 10.3027 31.6533H28.9694C29.9359 31.6533 30.7194 32.4368 30.7194 33.4033C30.7194 34.3698 29.9359 35.1533 28.9694 35.1533H10.3027C9.33624 35.1533 8.55273 34.3698 8.55273 33.4033Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.55273 43.9033C8.55273 42.9368 9.33624 42.1533 10.3027 42.1533H28.9694C29.9359 42.1533 30.7194 42.9368 30.7194 43.9033C30.7194 44.8698 29.9359 45.6533 28.9694 45.6533H10.3027C9.33624 45.6533 8.55273 44.8698 8.55273 43.9033Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.55273 22.9033C8.55273 21.9368 9.33624 21.1533 10.3027 21.1533H47.6361C48.6026 21.1533 49.3861 21.9368 49.3861 22.9033C49.3861 23.8698 48.6026 24.6533 47.6361 24.6533H10.3027C9.33624 24.6533 8.55273 23.8698 8.55273 22.9033Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.55273 12.4033C8.55273 11.4368 9.33624 10.6533 10.3027 10.6533H47.6361C48.6026 10.6533 49.3861 11.4368 49.3861 12.4033C49.3861 13.3698 48.6026 14.1533 47.6361 14.1533H10.3027C9.33624 14.1533 8.55273 13.3698 8.55273 12.4033Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2194 39.2367C34.2194 38.2702 35.0029 37.4867 35.9694 37.4867H47.6361C48.6026 37.4867 49.3861 38.2702 49.3861 39.2367C49.3861 40.2032 48.6026 40.9867 47.6361 40.9867H35.9694C35.0029 40.9867 34.2194 40.2032 34.2194 39.2367Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8027 31.6533C42.7692 31.6533 43.5527 32.4368 43.5527 33.4033V45.07C43.5527 46.0365 42.7692 46.82 41.8027 46.82C40.8362 46.82 40.0527 46.0365 40.0527 45.07V33.4033C40.0527 32.4368 40.8362 31.6533 41.8027 31.6533Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListAdd);
export default __webpack_public_path__ + "static/media/list-add.8948244d.svg";
export { ForwardRef as ReactComponent };